import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "./Modal";
export const FullScreenModal = (props) => (_jsx(Modal, { ...props, fullScreen: true }));
